// extracted by mini-css-extract-plugin
export var columnList = "_9z-0";